module.exports = __webpack_public_path__ + "img/40_69_014_570.9335a9dc.jpg";